<template>
  <el-dialog ref="configOperation" :title="curConfigData.title" size="small">
    <el-form ref="form" :model="form" label-width="110px">
      <el-form-item label="对应联表字段">
        <el-select v-model="form.field_id" size="small">
          <el-option 
            v-for="item in curConfigData.fields"
            :label="item.default.title"
            :value="item.default.field_id">
            <span>{{ item.default.name }}（{{ item.default.title }}）</span>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="分隔符" v-if="isCascader">
        <el-input v-model.trim="form.link_code" placeholder='请输入' class="h-40 w-200"></el-input>
      </el-form-item>
      <el-form-item label="查无数据时">
        <el-radio 
        class="radio m-r-20" 
        v-for="type in dealType" 
        v-model="form.deal_type" 
        :label='type.id'>
        {{type.name}}
      </el-radio>
      </el-form-item>
      <el-table
        :data="form.fields"
        label="自动补充字段内容"
        style="width: 100%">
        <el-table-column
          label="字段">
          <template scope="scope">
            <el-select v-model="scope.row.field_id" size="small">
              <el-option 
                v-for="item in curConfigData.fields"
                :label="item.default.title"
                :value="item.default.field_id">
                <span>{{ item.default.name }}（{{ item.default.title }}）</span>
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          label="类型">
          <template scope="scope">
            <el-select v-model="scope.row.type" size="small">
              <el-option 
                v-for="item in types"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          label="内容">
          <template scope="scope">
            <el-input v-if="scope.row.type == 10" v-model="scope.row.content" placeholder="请输入" class="w-150 m-r-10"></el-input>
            <el-input v-else-if="scope.row.type == 50" v-model="scope.row.content" placeholder="请输入英文列号" class="w-150 m-r-10"></el-input>
            <!-- <el-input v-else v-model="scope.row.content" placeholder="" :disabled="true" class="w-150 m-r-10"></el-input> -->
          </template>
        </el-table-column>
        <el-table-column
          label="操作">
          <template scope="scope">
            <el-button size="small" type="danger" @click="deleteRow(scope.$index)">删除</el-button>
          </template>  
        </el-table-column>
      </el-table>
      <div class="tx-c m-t-10">
        <el-button type="primary" @click="addRow">添加一行</el-button>
      </div>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="confirmDepentConfig">保 存</el-button>
    </span>
  </el-dialog>
</template>

<script>
  /**
   * @param Array keyDepent 从属字段
   * @param Array showName 显示名数组
   */
  export default {
    props: {
      curConfigData: {
        type: Object,
        default() {
          return {}
        }
      }
    },
    name: 'configOperation',
    data() {
      return {
        isCascader: false,
        form: {
          field_id: 0,
          deal_type: 0,
          link_code: '',
          fields: []
        },
        types: [
          { name: '常量', id: 10 },
          { name: '当前时间戳', id: 20 },
          { name: '导入用户ID', id: 30 },
          { name: '导入用户姓名', id: 40 },
          { name: '导入的列', id: 50 }
        ],
        dealType: [
          { name: '本条导入失败', id: 10 },
          { name: '外键赋空值', id: 20 },
          { name: '添加链表数据', id: 30 }
        ],
        importConfigObj: {
          field_id: '',
          type: '',
          content: ''
        }
      }
    },
    methods: {
      openDialog() {
        this.$refs.configOperation.open()
        if (this.curConfigData.title == '级联选择') {
          this.isCascader = true
        } else {
          this.isCascader = false
        }
        if (this.curConfigData.form.fields) {
          this.form = _.cloneDeep(this.curConfigData.form)
        } else {
          this.form = {
            field_id: 0,
            deal_type: 0,
            link_code: '',
            fields: []
          }
        }
      },
      closeDialog() {
        this.$refs.configOperation.close()
      },
      addRow() {
        this.form.fields.push(_.cloneDeep(this.importConfigObj))
      },
      deleteRow(index) {
        this.form.fields.splice(index, 1)
      },
      confirmDepentConfig() {
        if (!this.isCascader) {
          delete this.form.link_code
        }
        this.$emit('confirmConfigOperation', this.form)
        this.closeDialog()
      }
    }
  }
</script>


// WEBPACK FOOTER //
// configOperation.vue?19f75a02